import * as M from "@discovery/prelude/lib/data/maybe";
export const defaultImage = {
    alias: M.of(""),
    kind: "string",
    default: M.of(true),
    height: 100,
    width: 100,
    src: "string",
    title: M.of(""),
    description: M.of(""),
    cropCenter: M.of({
        x: 100,
        y: 100,
    }),
};

